export default "__VITE_ASSET__5rO3Gb3k__"